export default __webpack_public_path__ + "static/media/dripper-selected.af1ffe3d.png";